import React from 'react';

import AuthTemplate from '@src/templates/Auth';
import SignUpForm from '@src/components/forms/SignUpForm';
import SignUpIllustrationSrc from '@public/img/illustrations/sign-up.svg';

const SignUpTemplate = () => (
  <AuthTemplate
    illustrationSrc={SignUpIllustrationSrc}
    illustrationAlt="Two students looking at a computer screen with a form inside.">
    <SignUpForm />
  </AuthTemplate>
);

export default SignUpTemplate;
